import { mapState, mapMutations, mapActions } from 'vuex'
import Dialog from '../components/Dialog/'

// 用户登录
export default {
    computed: {
        ...mapState('user', {
            userID: 'userID',
            username: 'username',
            isLogged: 'isLogged'
        })
    },
    methods: {
        ...mapActions('user', {
            $_checkUserState: 'checkUserState'
        }),
        ...mapMutations('user', {
            $_login: 'login',
            $_logout: 'logout'
        }),
        $_openLoginModal() {
            Dialog.confirm({
                okText: '去登录',
                title: '友情提示',
                message: '您好，检测到您未登录！立即登录？',
                onOk: this.$_login
            })
        }
    }
}
